import type { KindMap } from 'v5/core/form-schema/formKinds.types';
import { ListBlocksField } from './ListBlocksField';
import { ListItemsField, type ListItemsFieldProps } from './ListItemsField';
import { hasListLines, ListLinesField } from './ListLinesField';

/**
 * A list unit's rows: a line per row when a row is one field whose kind fits
 * a line (`FieldKit.listRow`); the row editors of `ListItemsField` when that
 * one field's kind names its rows (rates); else a block per row (an array
 * field group).
 */
export function ListRowsField<M extends KindMap<M>>(
  props: ListItemsFieldProps<M>
) {
  const { fields } = props.unit.item;
  if (hasListLines(props.kit, fields)) return <ListLinesField {...props} />;
  if (fields.length === 1 && props.kit[fields[0].kind].RowHeading) {
    return <ListItemsField {...props} />;
  }
  return <ListBlocksField {...props} />;
}
